import { Message, MessageTypes } from "./Message/Message";
import { getHolidayDeliveryWarning } from "../utils/delivery.utils";
import { Trans, useTranslation } from "react-i18next";
import { Box, Link } from "../common/components";
import { BoxProps } from "@mui/material";

interface Props {
  boxProps?: BoxProps;
}

const HolidayWarning = ({ boxProps }: Props) => {
  const { t } = useTranslation();
  const holidayDeliveryWarning = getHolidayDeliveryWarning();

  if (holidayDeliveryWarning.key === "") {
    return null;
  }

  return (
    <Box {...boxProps}>
      {holidayDeliveryWarning.phase === 1 && (
        <Message
          message={
            <Trans
              t={t}
              i18nKey={holidayDeliveryWarning.key}
              components={[
                <Link
                  to="mailto:info@jameo.com"
                  style={{ fontSize: "16px" }}
                />,
              ]}
            />
          }
          messageIcon="emergency_home"
          type={MessageTypes.SUCCESS}
          fullWidth={false}
        />
      )}
      {holidayDeliveryWarning.phase === 2 && (
        <Message
          message={
            <Trans
              t={t}
              i18nKey={holidayDeliveryWarning.key}
              components={[
                <Link
                  to="mailto:info@jameo.com"
                  style={{ fontSize: "16px" }}
                />,
              ]}
            />
          }
          messageIcon="emergency_home"
          fullWidth={false}
        />
      )}
      {holidayDeliveryWarning.phase === 3 && (
        <Message
          message={t(holidayDeliveryWarning.key)}
          messageIcon="emergency_home"
          fullWidth={false}
        />
      )}
    </Box>
  );
};

export default HolidayWarning;
